// extracted by mini-css-extract-plugin
export var logo = "index-module--logo--fccf9";